import types from './types';
import { ThunkDispatch } from "redux-thunk";
import api from 'constants/api';
import _get from "lodash/get";

export interface AnnouncementResponse {
  [index: number]: {
    "RmiUid": number,
    "RmiLocation": null,
    "RmiSubject": string,
    "RmiContents": string,
    "RmiBackgroundColor": null,
    "RmiFileLink": null,
    "RmiStartTime": null,
    "RmiEndTime": null,
    "RmiDisableLogon": string,
    "RmiCreatedBy": null,
    "RmiCreatedDate": string
    "RmiModifiedBy": null,
    "RmiModifiedDate": string
  }
}

export const showAnnouncementBar = () => (dispatch: ThunkDispatch<any, any, any>, getState: any) => {
  dispatch({ type: types.SHOW_ANNOUNCEMENT_BAR });
  return getState().persistedReducer.appAnnouncements;
};

export const closeAnnouncementBar = () => (dispatch: ThunkDispatch<any, any, any>, getState: any) => {
  dispatch({ type: types.CLOSE_ANNOUNCEMENT_BAR });
  return getState().persistedReducer.appAnnouncements;
};

export const showUrgentAnnouncement = () => (dispatch: ThunkDispatch<any, any, any>, getState: any) => {
  dispatch({ type: types.SHOW_URGENT_ANNOUNCEMENT_BAR });
  return getState().persistedReducer.appAnnouncements;
};

export const closeUrgentAnnouncementBar = () => (dispatch: ThunkDispatch<any, any, any>, getState: any) => {
  dispatch({ type: types.CLOSE_URGENT_ANNOUNCEMENT_BAR });
  return getState().persistedReducer.appAnnouncements;
};


